let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bxAVQ")).then(() => parcelRequire('9B1xP'));